import FAQ from 'features/FAQ';
import { useTitle } from '../helpers';

/**
 * @page Absence page
 */
const FaqPage = () => {
  useTitle('Часто задаваемые вопросы');

  return (
    <div>
      <FAQ />
    </div>
  );
};

export default FaqPage;
